import React from "react";
import { motion } from "framer-motion";

// Hero & right content images (replace inside src/assets/)
import heroImg from "../assets/9.jpg";
import contentImg from "../assets/1.jpg";

const Escalators = () => {
  return (
    <div className="w-full">
      {/* Hero Section */}
      <div
        className="w-full h-[430px] relative flex items-center justify-start px-6 md:px-12"
        style={{
          backgroundImage: `url(${heroImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="absolute inset-0 bg-black/40" />
        <motion.div
          className="relative p-4 md:p-6 rounded-md"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2 }}
        >
          <p className="text-white text-sm md:text-base mb-1 cursor-pointer">
            Home
          </p>
          <motion.h1
            className="text-white text-2xl md:text-4xl font-bold"
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            transition={{ duration: 1.5, ease: "easeOut" }}
          >
            Escalators & Public Center Solutions
          </motion.h1>
        </motion.div>
      </div>

      {/* Left Content + Right Image */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 flex flex-col md:flex-row items-start gap-10">
        {/* Left Content */}
        <motion.div
          className="md:w-1/2 space-y-6"
          initial={{ opacity: 0, x: 80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          <p className="text-gray-700 text-lg leading-relaxed text-justify font-semibold">
            Commercial Escalators
          </p>
          <p className="text-gray-700 text-lg leading-relaxed text-justify">
            WVT Escalators are built complying at the State-of-the-Art Escalator
            designed and built for safety, reliability, comfort and quiet
            operation. Modular design of every component meets as per customer’s
            requirements.
          </p>
          <p className="text-gray-700 text-lg leading-relaxed text-justify">
            Landings: As per EN 115, the entrances to both landings have been
            given enough space to facilitate traffic flow.
          </p>
          <p className="text-gray-700 text-lg leading-relaxed text-justify">
            Design: Modular Design of each component, hence WVT escalators can
            be adapted to meet every customer need.
          </p>
          <p className="text-gray-700 text-lg leading-relaxed text-justify">
            Balustrade: Design with vertical safety glass, 10mm tempered glass
            and hairline ST that adds beauty and safety together.
          </p>
          <p className="text-gray-700 text-lg leading-relaxed text-justify">
            Operation: Red Emergency stop button, up/down key switches. Etched
            ST/ST with anti-slip pattern landing plates.
          </p>
        </motion.div>

        {/* Right Image */}
        <motion.div
          className="md:w-1/2 w-full overflow-hidden rounded-2xl shadow-2xl"
          initial={{ opacity: 0, x: -80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1.2 }}
        >
          <img
            src={contentImg}
            alt="Escalators"
            className="w-full h-[350px] md:h-[400px] object-cover rounded-2xl"
          />
        </motion.div>
      </div>

  <motion.div
  className="max-w-7xl mx-auto px-6 md:px-12 py-16 space-y-6"
  initial={{ opacity: 0, y: 50 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 1.5 }}
>
  <div>
    <p className="text-gray-900 font-semibold text-lg">For all exterior WVT commercial and public center’s</p>
  </div>

  <div>
    <p className="text-gray-900 font-semibold text-lg">Heavy-Duty Escalators</p>
    <ul className="list-disc list-inside text-gray-700">
      <li>
        To meet the client requirements of high-traffic public utilities, specially designed Glide Mass Transit Escalators are suited for continuous large crowds, indoor or outdoor, and operate perfectly under all climatic conditions.
      </li>
    </ul>
  </div>

  <div>
    <p className="text-gray-900 font-semibold text-lg">Drive-Chain Contact</p>
    <ul className="list-disc list-inside text-gray-700">
      <li>This contact monitors the drive-chain for breakage. When actuated, the contact will stop the escalator.</li>
    </ul>
  </div>

  <div>
    <p className="text-gray-900 font-semibold text-lg">Phase Monitor</p>
    <ul className="list-disc list-inside text-gray-700">
      <li>A safety feature which monitors the main power supply and disables on event of phase failure or reversal.</li>
    </ul>
  </div>

  <div>
    <p className="text-gray-900 font-semibold text-lg">Maintenance locking device</p>
    <ul className="list-disc list-inside text-gray-700">
      <li>The normal key start will be invalid. The inspection sockets in up and down machine room aren’t usable at same time.</li>
    </ul>
  </div>

  <div>
    <p className="text-gray-900 font-semibold text-lg">Speed Monitor</p>
    <ul className="list-disc list-inside text-gray-700">
      <li>Monitors the speed of the flywheel as well as avoids reversing. Will stop for speed over 120% or under 80%.</li>
    </ul>
  </div>
</motion.div>

    </div>
  );
};

export default Escalators;
